import { HeroSection } from "../components/HeroSection";
import { SEO } from "../components/Seo";

export default function HomePage() {
    return (
        <>
            <SEO url="/" />
            <div className="flex flex-col items-center text-gray-800 min-h-screen">
                <HeroSection />
            </div>
        </>
    );
}
